import React from 'react';
import './header.css';

interface Props {
  scrolled: boolean;
  dark: boolean;
  activeSection: string;
  onToggleTheme: () => void;
}

const NAV_LINKS = [
  { label: 'Me', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Education', href: '#education' },
  { label: 'Projects', href: '#projects' },
];

const Header: React.FC<Props> = ({ scrolled, dark, activeSection, onToggleTheme }) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.getElementById(href.slice(1));
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className={`site-header${scrolled ? ' header-visible' : ''}`}>
      <nav className="header-nav">
        <button className="theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
          {dark ? '☀' : '☽'}
        </button>
        {NAV_LINKS.map(({ label, href }) => {
          const id = href.slice(1);
          const active = activeSection === id;
          return (
            <a
              key={label}
              href={href}
              className={`header-link${active ? ' header-link-active' : ''}`}
              onClick={e => handleClick(e, href)}
            >
              {label}
            </a>
          );
        })}
      </nav>
    </header>
  );
};

export default Header;
